import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ActiveUserGuard } from './core/guards/active-user.guard';
import { AuthAdminGuard } from './core/guards/auth-admin.guard';
import { HomeComponent } from './home/home.component';

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    component: HomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'admin',
    canActivate: [AuthAdminGuard, ActiveUserGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'todo',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./user-todo/todo.module').then(m => m.UserTodoModule)
  },
  {
    path: 'data-entry-status',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./data-entry-status/data-entry-status.module').then(m => m.DataEntryStatusModule)
  },
  {
    path: 'filing-obligation',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./filing-obligation/filing-obligation.module').then(m => m.FilingObligationModule)
  },
  {
    path: 'general-questionnaire',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./general-questionnaire/general-questionnaire.module').then(m => m.GeneralQuestionnaireModule)
  },
  {
    path: 'taxes',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./taxes/taxes.module').then(m => m.TaxesModule)
  },
  {
    path: 'loss-contingency',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./loss-contingency/loss-contingency.module').then(m => m.LossContingencyModule)
  },
  {
    path: 'validation-review',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./validation-review/validation-review.module').then(m => m.ValidationReviewModule)
  },
  {
    path: 'aged-asset',
    canActivate: [ActiveUserGuard],
    loadChildren: () => import('./aged-asset/aged-asset.module').then(m => m.AgedAssetModule)
  },
  {
    path: '**',
    redirectTo: '/'
  },
  /*
  { path: 'admin-tools/manage-content', canActivate: [AuthAndRoleGuard], loadChildren: () => import('./admin-tools/admin-tools.module').then(m => m.AdminToolsModule) },
  { path: 'error', canActivate: [MsalGuard], loadChildren: () => import('./error/error.module').then(m => m.ErrorModule) },
  */
];

